import React from 'react';
import PropTypes from 'prop-types';
import shallowEqual from 'react-pure-render/shallowEqual';

import cx from 'classnames';
import b from 'b_';

import { Text, withHookProps } from 'platform-components';
import { POPUP_DIRECTIONS } from 'platform-components/constants';
import { coursePropType } from 'platform-components/src/utils/data-prop-types';

import { TeacherDetectPasteTumbler, useIsShowPastesAvailable } from 'common.components/teacher-detect-pastes';

import { CourseJournalLessonDescription } from '../__lesson-description/course-journal__lesson-description';
import { CourseJournalLessonsCarousel } from '../__lessons-carousel/course-journal__lessons-carousel';
import Cell from '../__table-cell/course-journal__table-cell';

import './course-journal__table-head.scss';

// Колонки, по которым возможна сортировка таблицы.
const SORTING_COLUMNS = {
    student: true,
    username: true,
    total_efficiency: true,
};

class CourseJournalTableHeadInner extends React.Component {
    static propTypes = {
        course: coursePropType.isRequired,
        fixed: PropTypes.bool,
        fullNameWidth: PropTypes.string,
        hoveredColumn: PropTypes.string,
        onOrderBy: PropTypes.func.isRequired,
        ordering: PropTypes.shape({
            field: PropTypes.string,
            order: PropTypes.string,
        }).isRequired,
        toggleColumnHover: PropTypes.func.isRequired,
        fieldToMod: PropTypes.object.isRequired,
        showPastesAvailable: PropTypes.bool,
    };

    state = {
        fixed: false,
        translationX: 0,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.fixed !== this.props.fixed) {
            if (nextProps.fixed) {
                window.addEventListener('scroll', this.onScrollPage, { passive: true });
            } else {
                window.removeEventListener('scroll', this.onScrollPage, { passive: true });
                this.setState({ translationX: 0 });
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.fixed !== this.props.fixed ||
            nextProps.hoveredColumn !== this.props.hoveredColumn ||
            nextState.translationX !== this.state.translationX ||
            !shallowEqual(nextProps.ordering, this.props.ordering) ||
            nextProps.course.id !== this.props.course.id
        );
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollPage, { passive: true });
    }

    onScrollPage = () => {
        if (typeof window.pageXOffset !== 'number') {
            return;
        }
        this.setState({ translationX: -window.pageXOffset });
    };

    getCellProps = (cellClassName, col) => {
        const { hoveredColumn, onOrderBy, ordering, toggleColumnHover } = this.props;
        let mix = this.props.fieldToMod[col];

        // Вручную состовляем классы модификаторов, так как `b_`
        // кроме самого модификатора добавляет класс элемента.
        if (hoveredColumn === col) {
            mix = cx(mix, `${cellClassName}_hovered`);
        }
        // Если нет заховеренной колонки или по заховеренной колонке уже
        // отсортирована таблица.
        if ((!hoveredColumn || hoveredColumn === col) && ordering.field === col) {
            mix = cx(mix, `course-journal__table-column_ordering_${ordering.order}`);
        }

        return {
            mix,
            onClick: SORTING_COLUMNS[col] && (() => onOrderBy(col)),
            onMouseEnter: () => toggleColumnHover(col),
            onMouseLeave: () => toggleColumnHover(),
        };
    };

    showDescription = (cellData) => {
        this.refs.lessonDescription.show(cellData);
    };

    hideDescription = () => {
        this.refs.lessonDescription.hide();
    };

    render() {
        const { course, fixed, fullNameWidth, showPastesAvailable } = this.props;
        const cellProps = this.getCellProps.bind(this, 'course-journal__table-cell');
        const className = b('course-journal', 'table-head', { fixed });
        const style = { transform: `translateX(${this.state.translationX}px)` };

        return (
            <div className={className}>
                <div className="course-journal__table-row" style={style}>
                    <Cell style={{ width: fullNameWidth }} {...cellProps('student')}>
                        <div className="course-journal__table-column-title">
                            <Text id="courseJournal.userFullName" />
                        </div>
                    </Cell>
                    <Cell {...cellProps('lessons')}>
                        <div className="course-journal__lessons-efficiency-title">
                            <Text id="courseJournal.efficiencyInLessons" />
                            {showPastesAvailable && (
                                <TeacherDetectPasteTumbler
                                    fromOrigin="course_journal"
                                    tooltipDirection="top"
                                    withTagNew={true}
                                />
                            )}
                        </div>
                        <CourseJournalLessonsCarousel
                            courseId={course.id}
                            heading
                            hideDescription={this.hideDescription}
                            lessons={course.lessons}
                            showDescription={this.showDescription}
                        />
                        <CourseJournalLessonDescription
                            direction={fixed ? POPUP_DIRECTIONS.BOTTOM_RIGHT : POPUP_DIRECTIONS.TOP_RIGHT}
                            ref="lessonDescription"
                        />
                    </Cell>
                    <Cell {...cellProps('total_efficiency')}>
                        <div className="course-journal__table-column-title">
                            <Text id="courseJournal.efficiency" />
                        </div>
                    </Cell>
                </div>
            </div>
        );
    }
}

export const CourseJournalTableHead = withHookProps(useIsShowPastesAvailable, {
    mapOwnProps: ({ course: { subject } }) => subject,
    hookPropKey: 'showPastesAvailable',
})(CourseJournalTableHeadInner);
